import React from 'react';
import {
	NavLink,
	Link
} from 'react-router-dom'


class ProjectInfoModal extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount(){
        // open and close modal
        let root = document.documentElement;
        let openModal = document.querySelector('.open-modal');
        let closeModal = document.querySelector('.close-modal');
        let closeModalGotoContact = document.querySelector('.close-modal-and-goto-contact');
        let modal = document.querySelector('.mole__side--modal');
   
        openModal.addEventListener('click', () => {
            modal.classList.add('is-showing');
            root.classList.add('bound');
        });
      
        closeModal.addEventListener('click', () => {
            modal.classList.remove('is-showing');
            root.classList.remove('bound');
        });

        closeModalGotoContact.addEventListener('click', () => {
            modal.classList.remove('is-showing');
            root.classList.remove('bound');
            window.scrollTo(0, document.body.scrollHeight);
            // setTimeout(() => {
            //     document.querySelector('footer .mole__menu--footer').classList.add('white');
            // }, 200);
        });
        

        // close modal on Esc press
        window.addEventListener('keydown', (e) => {
            if(e.key == "Escape") {
                if(modal.classList.contains('is-showing')){
                    modal.classList.remove('is-showing');
                    root.classList.remove('bound');
                }
            }
        });


        // project info btn hide and show
        let wScrollY;
       
        let pInfoBtn = document.querySelector('.btn--projectInfo');
        let pInfoBtnShowPoint = document.querySelector('.mole__hero').offsetHeight;
        window.addEventListener('scroll', () => {
            wScrollY = window.scrollY;
            let mainElem = document.querySelector('main').offsetHeight;
            console.log(mainElem);
            if(wScrollY > pInfoBtnShowPoint){
                

                pInfoBtn.classList.remove('hide');

                if(wScrollY > (pInfoBtnShowPoint * 2)){
                    pInfoBtn.classList.add('collapsed');
                }
                else{
                    pInfoBtn.classList.remove('collapsed');
                }

                if(wScrollY >= (mainElem - (pInfoBtnShowPoint + 100))) {
                    pInfoBtn.classList.add('hide');
                }
                else{
                    pInfoBtn.classList.remove('hide');
                }
            }
            else{
                pInfoBtn.classList.add('hide');
                pInfoBtn.classList.remove('collapsed');
            }
        });
    }

    render() {
        let { details } = this.props;
        return (
            <React.Fragment>
                {/* <section className="mole__side--modal bg-general fixed mb-0"> */}
                <section className="mole__side--modal bg-general fixed mb-0">
                    <div className="main-container">
                        <div className="inner-container">
                            <h2 className="font-lg-head">{details.post_title}</h2>
                            
                            <div className="grid">
                                <table className="--table-info">
                                    <tbody>
                                        {details.completion_year && <tr><td>Completion</td><td>{details.completion_year}</td></tr>}
                                        {details.sector && <tr><td>Sector</td><td>{details.sector}</td></tr>}
                                        {details.location && <tr><td>Location</td><td>{details.location}</td></tr>}
                                        {details.client && <tr><td>Client</td><td>{details.client}</td></tr>}
                                        {details.photography && <tr><td>Photography</td><td>{details.photography}</td></tr>}
                                    </tbody>
                                </table>

                                <article className="column-content desc" dangerouslySetInnerHTML={{__html:details.content}} />
                            </div>

                            <div className="grid mt-auto align-items-end">
                                <a href="javascript:" className="link btn_prev close-modal c-hvr-white">Back</a>
                                <a href="javascript:" className="link font-md close-modal-and-goto-contact">To discuss your project <br/>Get in touch</a>
                            </div>
                        </div>
                    </div>
                </section>    
        
            </React.Fragment>
        );
    }
}
export default ProjectInfoModal;



// WEBPACK FOOTER //
// ./src/components/Projects/Marmalade/ProjectInfoModal.js